<template>
    <div class="pagination">
        <el-pagination
            :current-page="pageIndex"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
            background
            >
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        pageIndex: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        pageSizes: {
            type: Array,
            default: () => [10, 20, 30, 40]
        }
    },
    methods: {
        handleCurrentChange(page) {
            this.$emit('change', page,this.pageSize);
        },
        handleSizeChange(size) {
            this.$emit('change', this.pageIndex,size);
        },
    }
}
</script>

<style scoped lang="scss">
.pagination {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    
    ::v-deep .el-pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        
        // 总数显示样式
        .el-pagination__total {
            color: #606266;
            font-size: 14px;
            margin-right: 20px;
        }
        
        // 每页条数选择器样式
        .el-pagination__sizes {
            margin-right: 20px;
            
            .el-select {
                .el-input {
                    .el-input__inner {
                        border: 1px solid #dcdfe6;
                        border-radius: 0px;
                        padding: 0 30px 0 12px;
                        height: 32px;
                        line-height: 32px;
                        font-size: 14px;
                        color: #606266;
                        
                        &:hover {
                            border-color: #c0c4cc;
                        }
                        
                        &:focus {
                            // border-color: #409EFF;
                        }
                    }
                    
                    .el-input__suffix {
                        .el-select__caret {
                            color: #c0c4cc;
                        }
                    }
                }
                
                // 下拉选项样式
                .el-select-dropdown {
                    .el-select-dropdown__item {
                        &:hover {
                            background-color: #f5f7fa;
                        }
                        
                        &.selected {
                            color: #409EFF;
                            font-weight: bold;
                        }
                        
                        &.hover {
                            background-color: #f5f7fa;
                        }
                    }
                }
            }
        }
        
        // 分页按钮组样式
        .el-pager {
            display: flex;
            align-items: center;

            
            li {
                border: 1px solid #dcdfe6;
                background: #fff;
                color: #606266;
                margin: 0 2px;
                min-width: 32px;
                height: 32px;
                line-height: 30px;
                text-align: center;
                border-radius: 0px;
                cursor: pointer;
                transition: all 0.3s;
                
                &:hover {
                    // color: #409EFF;
                    // border-color: #409EFF;
                }
                
                &.active {
                    background: #fff;
                    color: #000;
                    border-color: #409EFF;
                    font-weight: 400;
                }
                
                &.disabled {
                    color: #c0c4cc;
                    cursor: not-allowed;
                    border-color: #ebeef5;
                    
                    &:hover {
                        color: #c0c4cc;
                        border-color: #ebeef5;
                    }
                }
            }
        }
        
        // 上一页下一页按钮样式
        .btn-prev,
        .btn-next {
            border: 1px solid #dcdfe6;
            background: #fff;
            color: #606266;
            margin: 0 2px;
            min-width: 32px;
            height: 32px;
            line-height: 30px;
            text-align: center;
            border-radius: 0px;
            cursor: pointer;
            transition: all 0.3s;
            
            &:hover {
                // color: #409EFF;
                // border-color: #409EFF;
            }
            
            &.disabled {
                color: #c0c4cc;
                cursor: not-allowed;
                border-color: #ebeef5;
                
                &:hover {
                    color: #c0c4cc;
                    border-color: #ebeef5;
                }
            }
        }
        
        // 跳转页面样式
        .el-pagination__jump {
            display: flex;
            align-items: center;
            margin-left: 20px;
            
            .el-pagination__goto {
                color: #606266;
                font-size: 14px;
                margin-right: 8px;
            }
            
            .el-input {
                width: 50px;
                margin: 0 8px;
                
                .el-input__inner {
                    border: 1px solid #dcdfe6;
                    border-radius: 0px;
                    padding: 0 8px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    color: #606266;
                    text-align: center;
                    
                    &:hover {
                        border-color: #c0c4cc;
                    }
                    
                    &:focus {
                        // border-color: #409EFF;
                    }
                }
            }
            
            .el-pagination__classifier {
                color: #606266;
                font-size: 14px;
            }
        }
    }
}

// 全局样式，用于覆盖el-select下拉选项
::v-deep .el-select-dropdown {
    .el-select-dropdown__item {
        &:hover {
            background-color: #f5f7fa;
        }
        
        &.selected {
            color: #409EFF !important;
            font-weight: bold;
        }
        
        &.hover {
            background-color: #f5f7fa;
        }
    }
}

// 更强的全局样式覆盖
:global(.el-select-dropdown) {
    .el-select-dropdown__item {
        &.selected {
            color: #409EFF !important;
            font-weight: bold;
        }
    }
}

// 使用更具体的选择器
:global(.el-select-dropdown .el-select-dropdown__item.selected) {
    color: #409EFF !important;
}
</style>
